import { Component, DestroyRef, EventEmitter, inject, input, Input, OnInit, Output, signal, SimpleChanges, OnChanges } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Accessibility } from '../../models/details.model';
import { takeUntil } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-accessibility-accordion',
  imports: [],
  templateUrl: './accessibility-accordion.html',
  styleUrl: './accessibility-accordion.scss'
})
export class AccessibilityAccordion implements OnInit, OnChanges {
  environment = environment;
  @Output() scroll = new EventEmitter<void>();
  readonly accessibilityAware = input<Accessibility[]>([])
  
  isOpen = signal(false);
  hasInclusionPolicy = '';
  hasTraining = '';
  filteredItems: Accessibility[] = [];
  private transloco = inject(TranslocoService);
  private destroyRef = inject(DestroyRef)
  accessibility_of_org = signal<string>('');
  ngOnInit(): void {
    this.transloco.selectTranslate('accessibility_of_org')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(value => {
      this.accessibility_of_org.set(value);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['accessibilityAware']?.currentValue) {
      const hasPolicy = this.accessibilityAware().some(item => item.Name === 'Do you have Disability Inclusion Policy');
      const hasTraining = this.accessibilityAware().some(item => item.Name === 'Do you provide Disability Inclusion Training for your Employees');

      if (hasPolicy && hasTraining) {
        this.hasInclusionPolicy = 'Organization has a disability and inclusion (D&I) policy and staff has received D&I training.';
      } else if (hasPolicy) {
        this.hasInclusionPolicy = 'Organization has an inclusion (D&I) policy.';
      } else if (hasTraining) {
        this.hasInclusionPolicy = 'Organization has a disability (D&I) policy.';
      } else {
        this.hasInclusionPolicy = '';
      }

      this.filteredItems = this.accessibilityAware().filter(item => 
        item.Name !== 'Do you have Disability Inclusion Policy' && 
        item.Name !== 'Do you provide Disability Inclusion Training for your Employees'
      );
    }
  }
  

}
